<section style="width:100%;">
  <div>
    <label class="fields bold-text">{{'raciTemplate.name' | translate}}</label>
    <input class="fields input-field" kendoTextBox [(ngModel)]="raciTemplate.name" />
  </div>
  <div style="margin-top: 20px">
    <label class="fields bold-text">{{'raciTemplate.status' | translate}}</label>
    <kendo-dropdownlist [(ngModel)]="raciTemplate.status" [data]="templateStatusList" textField="text"
                        valueField="value" [valuePrimitive]="true">
    </kendo-dropdownlist>
  </div>
</section>
<p *ngIf="raciTemplate?.isUsedInPortfolio">{{'raciTemplate.templateInUseEditMessage' | translate}}</p>

<div class="grid-wrapper">
  <section class="steps-section">
    <h2>{{'raciTemplate.createNewSteps' | translate}}</h2>
    <kendo-grid #stepsGrid [kendoGridBinding]="steps" kendoGridSelectBy="oid" [pageSize]="5" [pageable]="true"
                [scrollable]="'scrollable'" (edit)="editStepHandler($event)" [selectedKeys]="selectedIndexes"
                (cancel)="cancelStepHandler($event)" (save)="saveStepHandler($event)"
                (remove)="removeStepHandler($event)" (add)="addStepHandler($event)"
                (selectionChange)="onStepSelect($event)" class="responsive-kendo-grid" style="width: 100%; height: 60%; border-color: white;">
      <kendo-grid-column class="add-btn" [width]="100" title="ADD TASK" [style]="{'text-align': 'center'}" [headerStyle]="{'text-align': 'center'}">
        <ng-template kendoGridCellTemplate let-data class="add-btn">
          <span *ngIf="data.oid > 0" class="right-align k-icon k-i-plus plus" (click)="addNewTask(data)"></span>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="title" [title]="'raciTemplate.gridTitle' | translate | uppercase" [width]="220">
      </kendo-grid-column>
      <kendo-grid-column field="isProjectLevel" editor="boolean" [title]="'raciTemplate.projectLevel' | translate | uppercase" [width]="220" >
        <ng-template kendoGridEditTemplate let-dataItem="dataItem">
          <input class="custom-checbox" type="checkbox" [(ngModel)]="dataItem.isProjectLevel" (click)="changeProjectLevelStatus(dataItem)" />
        </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem>
          <input class="custom-checbox" type="checkbox" [(ngModel)]="dataItem.isProjectLevel" disabled />
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="description" [title]="'raciTemplate.gridDescription' | translate | uppercase" [width]="220">
      </kendo-grid-column>
      <kendo-grid-column field="oid" [hidden]="true">
      </kendo-grid-column>
      <kendo-grid-command-column [headerClass]="'kendo-header-center'" [width]="180" class="add-btn">
        <ng-template kendoGridHeaderTemplate let-column>
          <span style="background-color: transparent; color:white;
                        border: none;" class="k-icon k-i-plus plus" kendoGridAddCommand></span>
        </ng-template>
        <ng-template kendoGridCellTemplate let-isNew="isNew">
          <div class="responsive-cell">
            <button kendoGridEditCommand [primary]="true">{{'raciTemplate.editBtn' | translate}}</button>
            <button kendoGridRemoveCommand>{{'raciTemplate.removeBtn' | translate}}</button>
            <button *ngIf="isNew" kendoGridSaveCommand [disabled]="formGroup?.invalid">
              {{'raciTemplate.addBtn' | translate}}
            </button>
            <button *ngIf="!isNew" kendoGridSaveCommand [disabled]="formGroup?.invalid">
              {{'raciTemplate.updateBtn' | translate}}
            </button>
            <button kendoGridCancelCommand> {{'raciTemplate.cancelBtn' | translate}} </button>
          </div>
        </ng-template>
      </kendo-grid-command-column>
    </kendo-grid>
  </section>

  <section class="tasks-section">

    <h2>{{'raciTemplate.addNewTasks' | translate}}</h2>
    <kendo-grid [kendoGridBinding]="tasksPerStep" #tasksGrid kendoGridSelectBy="oid" [pageSize]="5" [selectedKeys]="selectedTaskIndexes"
                [pageable]="true" [scrollable]="'scrollable'" [height]="200" style="width:100%; border-color: white;"
                (edit)="editTaskHandler($event)" (cancel)="cancelTaskHandler($event)" (save)="saveTaskHandler($event)"
                (remove)="removeTaskHandler($event)" class="responsive-kendo-grid"
                (selectionChange)="onTaskSelect($event)">
      <kendo-grid-column field="title" [title]="'raciTemplate.gridTitle' | translate | uppercase" [width]="200">
      </kendo-grid-column>
      <kendo-grid-column field="description" [title]="'raciTemplate.gridDescription' | translate | uppercase" [width]="220">
      </kendo-grid-column>
      <kendo-grid-column field="typeId" [title]="'raciTemplate.gridType' | translate | uppercase" [headerStyle]="{'width': '15%'}" [style]="{'width': '15%'}">
        <ng-template kendoGridEditTemplate let-dataItem="dataItem">
          <kendo-dropdownlist [data]="taskTypes" [(ngModel)]="dataItem.typeId" [valuePrimitive]="true"
                              [textField]="'description'" [valueField]="'oid'" (valueChange)="changeTaskType($event)">
          </kendo-dropdownlist>
        </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem>
          {{dataItem.typeDescription}}
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-command-column [headerClass]="'kendo-header-center'" [width]="180">
        <ng-template kendoGridCellTemplate let-isNew="isNew">
          <div class="responsive-cell">
            <button kendoGridEditCommand [primary]="true">{{'raciTemplate.editBtn' | translate}}</button>
            <button kendoGridRemoveCommand>{{'raciTemplate.removeBtn' | translate}}</button>
            <button *ngIf="isNew" kendoGridSaveCommand [disabled]="formGroup?.invalid">
              {{'raciTemplate.addBtn' | translate}}
            </button>
            <button *ngIf="!isNew" kendoGridSaveCommand [disabled]="formGroup?.invalid">
              {{'raciTemplate.updateBtn' | translate}}
            </button>
            <button kendoGridCancelCommand>
            
              {{'raciTemplate.cancelBtn' | translate}}
            </button>
          </div>
        </ng-template>
      </kendo-grid-command-column>
    </kendo-grid>
  </section>

  <section class="relation-section">
    <h2>{{'raciTemplate.configuration' | translate}} </h2>
    <kendo-grid #configurationGrid [kendoGridBinding]="configuration" kendoGridSelectBy="oid" [pageSize]="5" [pageable]="true"
                [scrollable]="'scrollable'" [selectedKeys]="selectedIndexes"
                class="responsive-kendo-grid" style="width: 100%; height: 60%; border-color: white;">

      <kendo-grid-column field="dependency" [title]="'raciTemplate.gridDependency' | translate | uppercase" [width]="40">
        <ng-template kendoGridCellTemplate let-dataItem>
          <input class="custom-checbox" type="checkbox" [(ngModel)]="dataItem.dependency" (click)="changeDependencyStatus(dataItem)" />
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="title" [title]="'raciTemplate.gridTitle' | translate | uppercase" [width]="220">
      </kendo-grid-column>
    </kendo-grid>
  </section>

</div>

<section class="buttons-container">
  <button kendoButton class="save-btn" (click)="upsertTemplate()">{{'raciTemplate.save' | translate}}</button>
</section>
<data-loader></data-loader>
